"use strict";

define('model/meeting.person',['./base', 'datakit/util/url'], function (Model, _url) {
  function findValue(meetingPerson, name) {
    var av = findAttribueValue(meetingPerson, name);
    return av ? av.get('value') : '';
  }
  ;
  function findAttribueValue(meetingPerson, name) {
    var attributeValues = meetingPerson.get('attributes');
    return attributeValues ? attributeValues.find(function (av) {
      return av.get('attributeName') == name;
    }) : null;
  }
  ;
  var MeetingPerson = Model.extend({
    urlRoot: '/rs/api/meetingPerson/:meetingId/:personId',
    url: function url() {
      return _url.template(this.urlRoot, this);
    },
    defaults: {
      present: false
    },
    virtual: {
      'personId': Model.createKeyPathVirtual('person.id'),
      'meetingId': function meetingId() {
        var meeting = this.meeting;
        return meeting ? meeting.id : null;
      },
      degrees: function degrees() {
        return findValue(this, 'Degrees');
      },
      membership: function membership() {
        return findValue(this, 'Membership Status');
      },
      representation: function representation() {
        return findValue(this, 'Representation');
      },
      affiliation: function affiliation() {
        return findValue(this, 'Affiliation');
      },
      office: function office() {
        return findValue(this, 'Office');
      },
      scientificStatus: function scientificStatus() {
        return findValue(this, 'Scientific Status');
      },
      startDate: function startDate() {
        var av = findAttribueValue(this, 'Tenure');
        return av ? av.get('startDate') : null;
      },
      endDate: function endDate() {
        var av = findAttribueValue(this, 'Tenure');
        return av ? av.get('endDate') : null;
      }
    },
    childModels: {
      'person': 'Person',
      'meeting': 'Meeting',
      'attributes': 'AttributeValue'
    },
    sync: function sync(method, model, options) {
      return Backbone.sync('update', model, options);
    },
    toJSON: function toJSON() {
      var json = Model.prototype.toJSON.apply(this, arguments);
      delete json.id;
      return json;
    }
  });
  return MeetingPerson;
});

